export default __webpack_public_path__ + "static/media/alUSD.3873a8f9.svg";